import { audioTrackFeature } from "./features/audio-track.js";
import { bufferFeature } from "./features/buffer.js";
import { controlsFeature } from "./features/controls.js";
import { errorFeature } from "./features/error.js";
import { fullscreenFeature } from "./features/fullscreen.js";
import { liveFeature } from "./features/live.js";
import { metadataFeature } from "./features/metadata.js";
import { pipFeature } from "./features/pip.js";
import { playbackFeature } from "./features/playback.js";
import { playbackRateFeature } from "./features/playback-rate.js";
import { qualityFeature } from "./features/quality.js";
import { remotePlaybackFeature } from "./features/remote-playback.js";
import { sourceFeature } from "./features/source.js";
import { streamTypeFeature } from "./features/stream-type.js";
import { textTrackFeature } from "./features/text-track.js";
import { timeFeature } from "./features/time.js";
import { volumeFeature } from "./features/volume.js";
import { createSelector } from "@videojs/store";
//#region src/dom/store/selectors.ts
/** Select the audio track state (audioTrackList, selectAudioTrack). */
const selectAudioTrack = createSelector(audioTrackFeature);
/** Select the buffer state (buffered and seekable ranges). */
const selectBuffer = createSelector(bufferFeature);
/** Select the controls state (controls visible, user-active). */
const selectControls = createSelector(controlsFeature);
/** Select the error state (error, dismissed, dismissError). */
const selectError = createSelector(errorFeature);
/** Select the fullscreen state (fullscreen active, availability). */
const selectFullscreen = createSelector(fullscreenFeature);
/** Select the live state (`liveEdgeStart`, `targetLiveWindow`). */
const selectLive = createSelector(liveFeature);
/** Select resolved content metadata and its user-config writers. */
const selectMetadata = createSelector(metadataFeature);
/** Select the PiP state (picture-in-picture active, availability). */
const selectPiP = createSelector(pipFeature);
/** Select the playback state (paused, ended, play, pause, toggle). */
const selectPlayback = createSelector(playbackFeature);
/** Select the playback rate state (playbackRate, playbackRates, setPlaybackRate). */
const selectPlaybackRate = createSelector(playbackRateFeature);
/** Select the quality state (videoRenditionList, activeVideoRendition, selectVideoRendition). */
const selectQuality = createSelector(qualityFeature);
/** Select the remote playback state (remote playback connection state, availability). */
const selectRemotePlayback = createSelector(remotePlaybackFeature);
/** Select the source state (src, type). */
const selectSource = createSelector(sourceFeature);
/** Select the stream type state (`'on-demand' | 'live' | 'unknown'`). */
const selectStreamType = createSelector(streamTypeFeature);
/** Select the text track state (chapters cues, thumbnail cues). */
const selectTextTrack = createSelector(textTrackFeature);
/** Select the time state (currentTime, duration, seek). */
const selectTime = createSelector(timeFeature);
/** Select the volume state (volume, muted, setVolume, setMuted). */
const selectVolume = createSelector(volumeFeature);
//#endregion
export { selectAudioTrack, selectBuffer, selectControls, selectError, selectFullscreen, selectLive, selectMetadata, selectPiP, selectPlayback, selectPlaybackRate, selectQuality, selectRemotePlayback, selectSource, selectStreamType, selectTextTrack, selectTime, selectVolume };

//# sourceMappingURL=selectors.js.map